export default __webpack_public_path__ + "static/media/icon_menu_virtual_servers_hover.abb9878c.svg";